function handleAlbumSlideshow(selectorGlide, selectorThumbs, autoplay = false, animationDuration = 500) {
    if (document.querySelector(selectorGlide)) {
        const glider = new Glide(selectorGlide, {
            animationDuration: animationDuration,
            autoplay: autoplay,
            gap: 0,
            type: autoplay ? 'carousel' : 'slider',
        });
        glider.mount();

        if (selectorThumbs) {
            const thumbs = document.querySelectorAll(selectorThumbs + ' [data-glide-dir]');
            console.log(selectorThumbs + ' [data-glide-dir]', thumbs);

            thumbs.forEach(thumb => {
                thumb.addEventListener('click', () => {
                    glider.go(thumb.getAttribute('data-glide-dir'));
                })
            })
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    handleAlbumSlideshow('.album .album__slideshow.glide', '.album .album__thumbs', 7000, 2000);
});
